import { render } from "./Native.vue?vue&type=template&id=32cead7d&scoped=true"
import script from "./Native.vue?vue&type=script&lang=js"
export * from "./Native.vue?vue&type=script&lang=js"

import "./Native.vue?vue&type=style&index=0&id=32cead7d&scoped=true&lang=less"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cead7d"]])

export default __exports__